import React from 'react';
import Search from '../components/Search/Search';

function SearchPage() {
  return (
    <div>
      <Search />
    </div>
  );
}

export default SearchPage;
